<template>
  <div class="page__subtitle">
    3. Заполните поля дополнительных сведений
  </div>
  <IndividualInfoSchoolchild v-if="type === 'schoolchild'" />
  <IndividualInfoStudent v-if="type === 'student'" />
  <IndividualInfoScience v-if="type === 'science'"/>
  <IndividualInfoPostgraduate v-if="type === 'postgraduate'"/>
</template>

<script>
import { defineComponent } from 'vue'
import { mapGetters } from "vuex"
import IndividualInfoSchoolchild from "@/modules/core/components/registration/individual/IndividualInfoSchoolchild.vue"
import IndividualInfoStudent from "@/modules/core/components/registration/individual/IndividualInfoStudent.vue"
import IndividualInfoScience from "@/modules/core/components/registration/individual/IndividualInfoScience.vue"
import pa_names from "@/modules/personal_account/routers/names"
import IndividualInfoPostgraduate from "@/modules/core/components/registration/individual/IndividualInfoPostgraduate.vue"

export default defineComponent({
  name: "RegistrationIndividualInfo",
  components: { IndividualInfoPostgraduate, IndividualInfoScience, IndividualInfoStudent, IndividualInfoSchoolchild },
  data () {
    return {
      type: undefined
    }
  },
  computed: {
    pa_names () {
      return pa_names
    },
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    })
  },
  created () {
    if (this.$route.query.type) {
      this.type = this.$route.query.type
    }
  },
})
</script>

<style scoped lang="scss">
.page__subtitle {
  margin-bottom: 50px;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 51px;
  text-align: center;

  color: #313743;
}

@media screen and (max-width: 1920px) {
  .page__subtitle {
    margin-bottom: 40px;
    font-size: 30px;
    line-height: 41px;
  }
}

@media screen and (max-width: 1279px) {
  .page__subtitle {
    font-size: 24px;
    line-height: 31px;
    padding: 0 40px;
  }
}

@media screen and (max-width: 768px) {
  .page__subtitle {
    margin-bottom: 40px;
    font-size: 18px;
    line-height: 22px;
    padding: 0 20px;
  }
}
</style>
